import * as React from 'react';

import * as styles from './styles.css';
import { IOffersFeedProps } from '../../../types';
import { ScrollableWrapper } from '../../commonComponents';
import { NarrowOfferRow } from '../NarrowOfferRow';

type TNarrowOffersFeedProps = Omit<IOffersFeedProps, 'feedViewState'>;

export const NarrowOffersFeed: React.FC<TNarrowOffersFeedProps> = ({
  scrollable,
  data,
  onOfferClick,
  showMoreBtn,
  selectable,
  activeOfferId,
  viewedOffers,
  hideButton,
}) => {
  const Component = scrollable ? ScrollableWrapper : 'div';

  return (
    <Component>
      <div className={styles['content']}>
        {data.map(offer => (
          <NarrowOfferRow
            key={offer.id}
            data={offer}
            onClick={() => onOfferClick(offer.id)}
            testId={`offers_history_listing_item_${offer.id}`}
            selectable={selectable}
            isActive={offer.id === activeOfferId}
            isViewed={viewedOffers.includes(offer.id)}
            hideButton={hideButton}
          />
        ))}
        {showMoreBtn}
      </div>
    </Component>
  );
};
